import { Browser, Page } from '@playwright/test';

declare const page: Page;
declare const browser: Browser;

/**
 * This const returns true if we are running a test with Playwright.
 */
const isPlaywrightTest = typeof page !== 'undefined' && typeof browser !== 'undefined';

export default isPlaywrightTest;
